var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9440",
    "data-name": "Grupo 9440",
    transform: "translate(-655 -1010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_396",
    "data-name": "Caminho 396",
    d: "M281,296H231a15,15,0,0,1-15-15V231a15,15,0,0,1,15-15h50a15,15,0,0,1,15,15v50A15,15,0,0,1,281,296Z",
    transform: "translate(439 794)",
    fill: "#fef9f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2040",
    "data-name": "Grupo 2040",
    transform: "translate(674 1028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3357",
    "data-name": "Caminho 3357",
    d: "M2831.77,16l1.96-3.779,3.2,6.175,7.2.643-5.216,4.855,1.244,6.175-6.426-2.778-1.811.783",
    transform: "translate(-2801.818 -12.22)",
    fill: "none",
    stroke: "#fcdea4",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3358",
    "data-name": "Caminho 3358",
    d: "M2596.129,16l-1.959-3.779-3.2,6.175-7.2.643,5.216,4.855-1.244,6.175,6.428-2.778,1.81.783",
    transform: "translate(-2583.77 -12.22)",
    fill: "none",
    stroke: "#fcdea4",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3359",
    "data-name": "Caminho 3359",
    d: "M2688.164,28.961l2.561,1.108-1.244-6.175,5.216-4.855-7.2-.643-3.2-6.175-3.2,6.175-7.2.643,5.216,4.855-1.244,6.175,2.562-1.108",
    transform: "translate(-2663.015 -12.22)",
    fill: "none",
    stroke: "#fcdea4",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3360",
    "data-name": "Caminho 3360",
    d: "M2776,184h1.933a2.6,2.6,0,0,1,1.932.966h1.932a2.029,2.029,0,0,1,1.932,1.932h1.933a2.029,2.029,0,0,1,1.932,1.932v9.662c0,1.955-1.932,3.529-1.932,4.831v.966",
    transform: "translate(-2752.783 -163.253)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_44",
    "data-name": "Linha 44",
    y2: 4.831,
    transform: "translate(27.081 21.713)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_45",
    "data-name": "Linha 45",
    y2: 3.865,
    transform: "translate(30.946 23.645)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3361",
    "data-name": "Caminho 3361",
    d: "M2738.357,355.865V352H2720v3.865",
    transform: "translate(-2703.547 -310.963)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3362",
    "data-name": "Caminho 3362",
    d: "M2694.094,133.526V121.932a1.932,1.932,0,0,0-1.932-1.932,1.906,1.906,0,0,0-1.933,1.9v14.761a.289.289,0,0,1-.505.188,24.186,24.186,0,0,0-3.36-3.324,2.545,2.545,0,0,0-2.5-.163,1.863,1.863,0,0,0-.523,2.936c2.5,2.769,3.38,6.482,5.922,8.821,1.017,1.017.966,1.389.966,1.932v1",
    transform: "translate(-2670.878 -106.982)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.7d03216480ed0ddb143692cf65b582f6.svg";
export { ForwardRef as ReactComponent };